import { Segmented, Tooltip } from "antd";
import type { ReactNode } from "react";
import { SCENARIO_COLOURS, scenarioLabel, scenAvailable } from "../model";
import type { Metric, Summary } from "../types";

/** A control with the dashboard's small upper-case caption above it. */
export const Field = ({
  label,
  children,
  className = ""
}: {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}) => <div className={`flex flex-col gap-1 ${className}`} data-sentry-component="Field" data-sentry-source-file="parts.tsx">
    <span className="text-[10.5px] uppercase tracking-wider text-gray-500">{label}</span>
    {children}
  </div>;
interface ScenarioPickerProps {
  summary: Summary;
  metric: Metric;
  /** The chosen scenario; "" for none. */
  value: string;
  dark: boolean;
  disabled?: boolean;
  onChange: (scenario: string) => void;
}

/** The scenarios as buttons with their colour, a scenario without the metric disabled. */
export const ScenarioPicker = ({
  summary,
  metric,
  value,
  dark,
  disabled,
  onChange
}: ScenarioPickerProps) => <Segmented value={value} disabled={disabled} options={summary.scenarios.map(s => {
  const available = scenAvailable(summary, metric, s.id);
  return {
    value: s.id,
    disabled: !available,
    label: <Tooltip title={available ? undefined : "Not available for this metric"}>
            <span className="inline-flex items-center gap-1.5">
              <span className="inline-block h-[9px] w-[9px] rounded-sm" style={{
          background: SCENARIO_COLOURS[s.id]?.[dark ? "dark" : "light"]
        }} />
              {scenarioLabel(summary, s.id)}
            </span>
          </Tooltip>
  };
})} onChange={scenario => onChange(scenario as string)} data-sentry-element="Segmented" data-sentry-component="ScenarioPicker" data-sentry-source-file="parts.tsx" />;